var exports = {
  "l": "xa15a2ab7--597ffd--phone",
};

module.exports = exports;
